import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';

import { PROTECTED_API_URL } from '@lib/core/tokens/api.tokens';

import { BulkOperationResult } from '../models/bulk-operation-result.model';
import { ProtocolImportCommit, ProtocolImportPreview, ProtocolImportRequest } from '../models/protocol-import.model';
import { ContinuationPage, ProtocolSearch } from '../models/protocol-search.model';
import { ProtocolTrademarksByInn } from '../models/protocol-trademark.model';
import { ProtocolValidationResult } from '../models/protocol-validation.model';
import { Protocol } from '../models/protocol.model';

@Injectable({ providedIn: 'root' })
export class ProtocolsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl: string;

  constructor(@Inject(PROTECTED_API_URL) apiUrl: string) {
    this.baseUrl = `${apiUrl}/protocols/v2`;
  }

  search(search: ProtocolSearch) {
    return this.http.post<ContinuationPage<Protocol>>(`${this.baseUrl}/search`, search);
  }

  getById(id: string) {
    return this.http.get<Protocol>(`${this.baseUrl}/${id}`);
  }

  create(protocol: Protocol) {
    return this.http.post<Protocol>(this.baseUrl, protocol);
  }

  validate(protocol: Protocol) {
    return this.http.post<ProtocolValidationResult>(`${this.baseUrl}/validate`, protocol);
  }

  getTrademarks(id: string) {
    return this.http.get<ProtocolTrademarksByInn>(`${this.baseUrl}/${id}/trademarks`);
  }

  importPreview(request: ProtocolImportRequest) {
    return this.http.post<ProtocolImportPreview>(`${this.baseUrl}/import/preview`, request);
  }

  importCommit(commit: ProtocolImportCommit) {
    return this.http.post<BulkOperationResult>(`${this.baseUrl}/import/commit`, commit);
  }

  update(id: string, protocol: Protocol) {
    return this.http.put<Protocol>(`${this.baseUrl}/${id}`, protocol);
  }

  delete(id: string) {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
